import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_WARMUP_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-band-shoulder-warmup",
    "name": "弹力带肩胛前后拉激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "resistance-band",
    "pattern": "弹力带肩水平外展活动",
    "legacyIds": [
      "band-shoulder-warmup",
      "band-shoulder-pull"
    ],
    "sourceId": "course-20261008-four-way-01-01",
    "targetMuscles": [
      "三角肌后束",
      "肩胛稳定肌群"
    ],
    "evidence": "主线程三帧比对四分化第1与4期同一弹力带前后拉，区别于过头绕肩"
  },
  {
    "id": "library-wall-scapular-protraction",
    "name": "靠墙单臂肩胛前引",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "靠墙单臂肩胛前引",
    "legacyIds": [
      "wall-scapular-protraction"
    ],
    "sourceId": "course-20261008-four-way-02-01",
    "targetMuscles": [
      "前锯肌",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-hip-adductor-machine",
    "name": "训练前仰卧器械髋内收",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "machine",
    "pattern": "仰卧器械髋内收",
    "legacyIds": [
      "hip-adductor-machine"
    ],
    "sourceId": "course-20261008-four-way-03-02",
    "targetMuscles": [
      "髋内收肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-side-lying-hip-adduct",
    "name": "训练前侧卧髋内收",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "侧卧徒手髋内收",
    "legacyIds": [
      "side-lying-hip-adduct"
    ],
    "sourceId": "course-20261008-four-way-03-03",
    "targetMuscles": [
      "髋内收肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-side-lunge-stretch",
    "name": "侧弓步动态热身",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "侧弓步动态髋活动",
    "legacyIds": [
      "side-lunge-stretch"
    ],
    "sourceId": "course-20261008-four-way-03-01",
    "targetMuscles": [
      "髋内收肌群",
      "臀部肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-band-chest-activate",
    "name": "弹力带胸部激活",
    "group": "warmup",
    "subCategory": "chest",
    "equipment": "resistance-band",
    "pattern": "弹力带胸部预激活",
    "legacyIds": [
      "home-band-chest-activate"
    ],
    "sourceId": "course-20261008-home-01-01",
    "targetMuscles": [
      "胸大肌",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-wall-handstand",
    "name": "靠墙倒立激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "靠墙倒立静态支撑",
    "legacyIds": [
      "home-wall-handstand"
    ],
    "sourceId": "course-20261008-home-01-02",
    "targetMuscles": [
      "三角肌",
      "前锯肌",
      "核心稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-prone-back-extension",
    "name": "俯卧背伸激活",
    "group": "warmup",
    "subCategory": "thoracic",
    "equipment": "bodyweight",
    "pattern": "俯卧躯干伸展活动",
    "legacyIds": [
      "home-prone-back-extension"
    ],
    "sourceId": "course-20261008-home-02-01",
    "targetMuscles": [
      "竖脊肌",
      "臀部肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-worlds-greatest-stretch",
    "name": "世界最伟大动态拉伸",
    "group": "warmup",
    "subCategory": "full-body",
    "equipment": "bodyweight",
    "pattern": "弓步胸椎旋转动态活动",
    "legacyIds": [
      "home-worlds-greatest-stretch"
    ],
    "sourceId": "course-20261008-home-03-01",
    "targetMuscles": [
      "髋部肌群",
      "胸椎活动肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-prone-y-raise",
    "name": "俯卧Y字激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "俯卧Y字肩胛上回旋",
    "legacyIds": [
      "home-prone-y-raise"
    ],
    "sourceId": "course-20261008-home-04-02",
    "targetMuscles": [
      "斜方肌下部",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-pec-minor-release",
    "name": "训练前胸小肌松解",
    "group": "warmup",
    "subCategory": "chest",
    "equipment": "foam-roller",
    "pattern": "胸小肌训练前松解",
    "legacyIds": [
      "ksw-warmup-pec-minor-release"
    ],
    "sourceId": "course-20261008-ksw-collection-01-02",
    "targetMuscles": [
      "胸小肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-pec-major-release",
    "name": "训练前胸大肌松解",
    "group": "warmup",
    "subCategory": "chest",
    "equipment": "foam-roller",
    "pattern": "胸大肌训练前松解",
    "legacyIds": [
      "ksw-warmup-pec-major-release"
    ],
    "sourceId": "course-20261008-ksw-collection-01-01",
    "targetMuscles": [
      "胸大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
